import { render, staticRenderFns } from "./composeEmailDrawer.vue?vue&type=template&id=83ffdf12&scoped=true"
import script from "./composeEmailDrawer.vue?vue&type=script&lang=js"
export * from "./composeEmailDrawer.vue?vue&type=script&lang=js"
import style0 from "./composeEmailDrawer.vue?vue&type=style&index=0&id=83ffdf12&lang=less&scoped=true"
import style1 from "./composeEmailDrawer.vue?vue&type=style&index=1&id=83ffdf12&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ffdf12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ffdf12')) {
      api.createRecord('83ffdf12', component.options)
    } else {
      api.reload('83ffdf12', component.options)
    }
    module.hot.accept("./composeEmailDrawer.vue?vue&type=template&id=83ffdf12&scoped=true", function () {
      api.rerender('83ffdf12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/components/composeEmailDrawer.vue"
export default component.exports